<script lang="ts">
import { ColumnFilter } from '@/generated/classes/ListData';
import SectionProjetList from '@/generated/sections/SectionProjetList.vue';
import { RessourceFwkButton, FwkButtons } from '@/ressources/globalRessources';
import { defineComponent } from "vue";

export default defineComponent({
  extends: SectionProjetList,
  name: 'SectionProjetListExtend',
  components: {},
  computed: {
    addLabel(): string {
      return RessourceFwkButton(FwkButtons.NEW_PROJET).label;
    },
  },
  methods: {
    defaultFilter(): void {
      {
        const columnFilter = new ColumnFilter();
        columnFilter.name = "dateDebut";
        columnFilter.sortDescending = true;
        this.activeFilters.push(columnFilter);
      }
    },
  },
});
</script>